module.exports = __webpack_public_path__ + "img/first-3-opened.d1e0b7d5.webp";